import { forwardRef } from 'react';

import Collapse from 'shopper/components/Collapse';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import Anchor from 'components/Anchor';
import Image from 'components/Image';

import useMyBlackFridayScheduler from 'hooks/useMyBlackFridayScheduler';

import placeholder from 'lib/placeholder';

const TOPICS = [
  {
    title: 'O que é o Promobit?',
    text: 'O Promobit é o lugar certo para quem quer encontrar as melhores pechinchas da internet! Nós fornecemos um espaço para que a nossa comunidade compartilhe ofertas, promoções e cupons imperdíveis que encontram pela internet!',
  },
  {
    title: 'O Promobit é confiável?',
    text: 'O Promobit é um site 100% confiável! Todos os links compartilhados são avaliados pelo nosso sistema e por nosso time de especialistas que garantem uma navegação completamente segura para nossa comunidade e visitantes.',
  },
  {
    title: 'Black Friday 2025 Promobit: a certeza do melhor preço!',
    text: 'Aqui você tem acesso a uma variedade imensa de produtos e apenas ofertas verdadeiras, desde os mais badalados para o evento, como celulares,TVs e Notebooks, até itens para limpeza da casa, como Mop, desinfetante e papel higiênico.\n Para ficar ainda melhor, nós possuímos uma equipe de especialistas, que trabalham ainda mais nesse período, conferindo se as promoções compartilhadas são de lojas confiáveis. Tudo para você comprar com preço baixo e segurança.',
  },
  {
    title: 'O que comprar na Black Friday 2025?',
    text: 'O principal evento de promoções do ano é uma ótima oportunidade para comprar produtos de qualquer categoria, seja itens mais simples como artigos de papelaria, até aparelhos mais duradouros como eletrodomésticos. porém durante a Black Friday vale muito a pena ficar atento a promoções para compras que não são tão relacionadas a data, como passagens áreas e até itens para jardinagem.',
  },
  {
    title: 'Como saber se o preço vai baixar na Black Friday?',
    text: 'Para ter certeza que o preço vai baixar na Black Friday 2025 vale a pena ficar de olho no histórico de preço e criar a sua lista de desejos no Promobit para receber a promoção do produto que você procura em primeira mão. Aqui verificamos o histórico da loja, do preço e garantimos entregar as verdadeiras promoções para os usuários.',
  },
  {
    title: 'Quando é a Black Friday 2025?',
    text: 'A Black Friday que neste ano de 2025  acontece no dia 28 de novembro, última sexta-feira do mês, assim como em todos os anos desde seu nascimento nos Estados Unidos, traz as maiores e melhores promoções do ano.',
  },
  {
    title: 'Cupons de desconto na Black Friday',
    text: 'Confira nossa seleção de cupons de desconto, pois trata-se de um recurso bem interessante que pode te ajudar com aqueles descontos na hora de fechar a sua compra que chegam até 60% em alguns casos.',
  },
];

const Faq = forwardRef((_, ref) => {
  const { activeCampaigns } = useMyBlackFridayScheduler();
  const faqCampaigns = activeCampaigns().filter(
    (campaign) => campaign.type === 'FAQ'
  );

  return (
    <section ref={ref} className="flex flex-col gap-4">
      <Heading size="size3">{placeholder('titles.faq')}</Heading>
      <div className="flex flex-col gap-4 lg:flex-row">
        <div className="flex flex-1 flex-col gap-4">
          <Text>{placeholder('descriptions.faqDescriptions')}</Text>
          {TOPICS.map(({ title, text }) => (
            <Collapse key={title} title={title}>
              <Text>{text}</Text>
            </Collapse>
          ))}
        </div>
        {faqCampaigns.length > 0 && (
          <div className="flex w-full flex-col gap-4 lg:w-5/12">
            {faqCampaigns.map(({ id, url, name, images }) => (
              <Anchor
                key={id}
                className="block"
                href={url}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Image
                  alt={`Imagem da loja ${name}`}
                  className="block h-fit w-full rounded-4 md:hidden"
                  height={90}
                  src={images.mobile}
                  width={350}
                />
                <Image
                  alt={`Imagem da loja ${name}`}
                  className="hidden h-fit w-full rounded-4 md:block"
                  height={170}
                  src={images.desktop}
                  width={1370}
                />
              </Anchor>
            ))}
          </div>
        )}
      </div>
    </section>
  );
});

Faq.displayName = 'Faq';

export default Faq;
